import { render, staticRenderFns } from "./MemberManage.vue?vue&type=template&id=67892e30&scoped=true"
import script from "./MemberManage.vue?vue&type=script&lang=js"
export * from "./MemberManage.vue?vue&type=script&lang=js"
import style0 from "./MemberManage.vue?vue&type=style&index=0&id=67892e30&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67892e30",
  null
  
)

export default component.exports